import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=46bf265f&scoped=true"
import script from "./empty.js?vue&type=script&lang=js&external"
export * from "./empty.js?vue&type=script&lang=js&external"
import style0 from "./empty.scss?vue&type=style&index=0&id=46bf265f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf265f",
  null
  
)

export default component.exports